// Mock data for PO Reconciliation

export const poReconciliationData = [
  {
    id: 'PO-2025-001',
    channel: 'TV',
    vendor: 'MBC Group',
    brand: 'Consumer Electronics',
    poAmount: 2800000,
    invoiceAmount: 2750000,
    actualSpend: 2750000,
    matched: true,
    variance: -1.8,
    status: 'Completed',
    date: '2025-01-15',
    region: 'UAE',
    invoices: [
      {
        id: 'INV-001',
        amount: 1400000,
        date: '2025-01-20',
        status: 'Paid',
        attachment: 'invoice_001.pdf'
      },
      {
        id: 'INV-002',
        amount: 1350000,
        date: '2025-01-25',
        status: 'Paid',
        attachment: 'invoice_002.pdf'
      }
    ],
    attachments: ['po_contract.pdf', 'media_plan.xlsx'],
    screenshots: ['campaign_proof_1.png', 'campaign_proof_2.png']
  },
  {
    id: 'PO-2025-002',
    channel: 'Digital',
    vendor: 'Google MENA',
    brand: 'Fashion Retail',
    poAmount: 1500000,
    invoiceAmount: 1650000,
    actualSpend: 1620000,
    matched: false,
    variance: 8.0,
    status: 'Pending Review',
    date: '2025-02-01',
    region: 'Saudi Arabia',
    invoices: [
      {
        id: 'INV-003',
        amount: 1650000,
        date: '2025-02-15',
        status: 'Pending',
        attachment: 'google_invoice.pdf'
      }
    ],
    attachments: ['insertion_order.pdf'],
    screenshots: ['google_campaign_1.png']
  },
  {
    id: 'PO-2025-003',
    channel: 'Print',
    vendor: 'Al Khaleej Newspapers',
    brand: 'Real Estate',
    poAmount: 800000,
    invoiceAmount: 785000,
    actualSpend: 785000,
    matched: true,
    variance: -1.9,
    status: 'Completed',
    date: '2025-02-10',
    region: 'UAE',
    invoices: [
      {
        id: 'INV-004',
        amount: 785000,
        date: '2025-02-20',
        status: 'Paid',
        attachment: 'print_invoice.pdf'
      }
    ],
    attachments: ['media_schedule.pdf'],
    screenshots: ['newspaper_ad_1.jpg']
  },
  {
    id: 'PO-2025-004',
    channel: 'Radio',
    vendor: 'Dubai FM Network',
    brand: 'Automotive',
    poAmount: 600000,
    invoiceAmount: 620000,
    actualSpend: 620000,
    matched: false,
    variance: 3.3,
    status: 'Dispute',
    date: '2025-02-05',
    region: 'UAE',
    invoices: [
      {
        id: 'INV-005',
        amount: 620000,
        date: '2025-02-25',
        status: 'Disputed',
        attachment: 'radio_invoice.pdf'
      }
    ],
    attachments: ['radio_contract.pdf'],
    screenshots: ['radio_log_1.pdf']
  },
  {
    id: 'PO-2025-005',
    channel: 'Outdoor',
    vendor: 'Hypermedia Qatar',
    brand: 'FMCG',
    poAmount: 1200000,
    invoiceAmount: 0,
    actualSpend: 0,
    matched: false,
    variance: 0,
    status: 'Awaiting Invoice',
    date: '2025-02-20',
    region: 'Qatar',
    invoices: [],
    attachments: ['outdoor_booking.pdf'],
    screenshots: ['billboard_location.jpg']
  },
  {
    id: 'PO-2025-006',
    channel: 'Digital',
    vendor: 'Meta MENA',
    brand: 'Tourism',
    poAmount: 2200000,
    invoiceAmount: 2180000,
    actualSpend: 2180000,
    matched: true,
    variance: -0.9,
    status: 'Completed',
    date: '2025-01-25',
    region: 'Egypt',
    invoices: [
      {
        id: 'INV-006',
        amount: 1100000,
        date: '2025-02-01',
        status: 'Paid',
        attachment: 'meta_invoice_1.pdf'
      },
      {
        id: 'INV-007',
        amount: 1080000,
        date: '2025-02-15',
        status: 'Paid',
        attachment: 'meta_invoice_2.pdf'
      }
    ],
    attachments: ['facebook_io.pdf', 'instagram_io.pdf'],
    screenshots: ['fb_campaign_1.png', 'ig_campaign_1.png']
  }
];

export const matchSuggestions = [
  {
    poId: 'PO-2025-002',
    suggestions: [
      {
        vendor: 'Google MENA',
        amount: 1620000,
        date: '2025-02-15',
        confidence: 85,
        reason: 'Vendor and date match, amount within 5% variance'
      }
    ]
  },
  {
    poId: 'PO-2025-004',
    suggestions: [
      {
        vendor: 'Dubai FM Network',
        amount: 620000,
        date: '2025-02-25',
        confidence: 92,
        reason: 'Exact vendor match, amount and date correlation'
      }
    ]
  }
];

export const poRegions = [
  'All Regions',
  'Saudi Arabia',
  'UAE',
  'Egypt',
  'Qatar',
  'Kuwait',
  'Iraq',
  'Morocco',
  'Jordan',
  'Oman',
  'Bahrain',
  'Lebanon',
  'Kazakhstan',
  'North Africa'
];

export const poVendors = [
  'All Vendors',
  'MBC Group',
  'Google MENA',
  'Meta MENA',
  'Al Khaleej Newspapers',
  'Dubai FM Network',
  'Hypermedia Qatar',
  'Saudi Broadcasting',
  'Arab Media Group',
  'Gulf Outdoor Media',
  'Rotana Media Services',
  'OSN Networks',
  'Anghami',
  'Snapchat MENA'
];